import { ExternalLink, Pin } from "lucide-react";
import { DiscordText, formatDate, relativeTime } from "@/lib/format";

export function DiscordMessageCard({ msg }) {
  const images = msg.attachments.filter((a) => a.is_image);
  const files = msg.attachments.filter((a) => !a.is_image);
  return (
    <article className="card-eden flex flex-col hover:border-zinc-500" data-testid={`news-card-${msg.id}`}>
      <header className="flex items-center gap-3 border-b border-eden-borderSubtle px-5 py-4">
        <img src={msg.author.avatar_url} alt="" className="h-9 w-9 rounded-full bg-eden-elevated" loading="lazy" width="36" height="36" />
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-semibold text-eden-text" data-testid="news-author">{msg.author.name}</p>
          <time dateTime={msg.timestamp} title={formatDate(msg.timestamp)} className="block text-xs text-eden-muted" data-testid="news-date">{relativeTime(msg.timestamp)}</time>
        </div>
        {msg.pinned && <Pin size={14} className="text-eden-orange" aria-label="Fixado" />}
      </header>
      <div className="flex-1 space-y-4 px-5 py-5">
        {msg.title && <h3 className="font-display text-lg font-semibold leading-snug text-eden-text" data-testid="news-title">{msg.title}</h3>}
        <DiscordText text={msg.content} />
        {msg.embeds.map((e, i) => (
          <div key={e.url || e.title || `embed-${i}`} className="rounded-sm border-l-2 bg-eden-elevated/60 p-4" style={{ borderColor: e.color ? `#${e.color.toString(16).padStart(6, "0")}` : "#0A9396" }}>
            {e.title && <p className="font-display font-semibold text-eden-text">{e.url ? <a href={e.url} target="_blank" rel="noopener noreferrer" className="hover:underline">{e.title}</a> : e.title}</p>}
            <DiscordText text={e.description} className="mt-1" />
            {e.fields?.length > 0 && (
              <dl className="mt-3 grid gap-3 sm:grid-cols-2">
                {e.fields.map((f) => (
                  <div key={f.name}><dt className="text-xs font-semibold text-eden-text">{f.name}</dt><dd className="text-xs text-eden-secondary"><DiscordText text={f.value} /></dd></div>
                ))}
              </dl>
            )}
            {e.image && <img src={e.image} alt="" className="mt-3 max-h-80 w-full rounded-sm object-cover" loading="lazy" />}
          </div>
        ))}
        {images.map((a) => (
          <a key={a.url} href={a.url} target="_blank" rel="noopener noreferrer" className="block overflow-hidden rounded-sm">
            <img src={a.url} alt={a.name || "Imagem da publicação"} className="max-h-96 w-full object-cover" loading="lazy" />
          </a>
        ))}
        {files.map((a) => (
          <a key={a.url} href={a.url} target="_blank" rel="noopener noreferrer" className="block text-sm text-eden-turquoise underline underline-offset-2">{a.name}</a>
        ))}
      </div>
      <footer className="border-t border-eden-borderSubtle px-5 py-3">
        <a href={msg.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-xs font-medium text-eden-secondary transition-colors hover:text-eden-orange" data-testid="news-open-discord">
          Abrir no Discord <ExternalLink size={12} aria-hidden="true" />
        </a>
      </footer>
    </article>
  );
}
